import {useContext} from 'react'
import {LocalContext} from './LocalContext'

const defaultTransform = value => value
const useTranslate = () => {
  const {
    translate = defaultTransform
  } = useContext(LocalContext)

  return translate
}
export default useTranslate
